import { Fragment, useEffect, useState } from "react";
import CustomMultiSelect from "vagaro-website-rendering/src/components/CustomMultiSelect";
import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { AddSection, EditSection, GetSectionCategories, GetSectionDetails, UpdateCategoriesForSection } from "../Utilities/SectionTemplateAPI";
import { SiteData } from "../Data/SiteData";
import Loader from "components/Common/Loader";
import ReactDOM from "react-dom";
import VGPopUp from "vagaro-website-rendering/src/components/Controls/VGPopUp";
import { OpenSectionCategoryPopup } from "./SectionCategoryMenu";
import { AlertConfirm } from "../ConfirmationPopups";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";

export enum SectionSaveType {
    Create = 0,
    EditContent = 1,
    EditCategories = 2
}

export function SaveSectionMenu({content,siteData,onDismiss,editId,saveType,inCategories,onUpdateCategories,srcNode}:{content:string,siteData:SiteData,onDismiss:()=>void,editId?:string,saveType:SectionSaveType,inCategories?:string[],onUpdateCategories?:()=>void,srcNode?:LayoutNode}){

    const [categories,setCategories] = useState<any[]>([]);
    const [selectedCategories,setSelectedCategories] = useState<string[]>(inCategories??[]);
    const [options,setOptions] = useState<{label:string,value:string}[]>([]);
    const [isLoading,setIsloading] = useState(true);


    useEffect(()=>{

        let dom = document.getElementById("save-section-btn");
        (dom as HTMLButtonElement).disabled = true;

        GetSectionCategories(siteData.userContext,(data:any)=>{
            setCategories(data);

            let options = data.map((item:any)=>{return {label:item.name,value:item.id}});
            setOptions(options);

            if(saveType === SectionSaveType.EditContent && editId && !inCategories){
                setIsloading(true);
                GetSectionDetails(siteData.userContext,editId,(data:any)=>{
                  
                    setSelectedCategories(data.categoryID);
                    setIsloading(false);
                },(error:any)=>{
                 
                    AlertConfirm("Error loading section details");
                    setIsloading(false);
                });
            }
            else
                setIsloading(false);
        },
        (error:any)=>{
            console.error(error);
            AlertConfirm("Error loading categories");
            setIsloading(false);
        }
        
        );
//eslint-disable-next-line
    },[]);


    const TrySave = ()=>{


        if(selectedCategories.length==0){
            AlertConfirm("Please select at least one category");
            return;
        }
       
        setIsloading(true);

        if( saveType===SectionSaveType.Create){
            AddSection(siteData.userContext,selectedCategories,content,
            (data:any)=>{
                setIsloading(false);
                if(onUpdateCategories){
                    onUpdateCategories();
                }

                if(siteData.designer){ // get the selected node and link it to its newly saved id so it can be updated without hassle
                    let selection = siteData.designer.latestSelection();
                    if(selection){
                        let node = selection.layout;
                        if(node.typename == wBComponentTypeNames.section){
                            node.content = data?.data?.data?.id;
                            siteData.designer.selectElementByLayoutObj(node);//reselect to refresh status
                        }
                        else{
                            while(node.parent){
                                node = node.parent;
                                if(node.typename == wBComponentTypeNames.section){
                                    node.content = data?.data?.data?.id;
                                    siteData.designer.selectElementByLayoutObj(node);//reselect to refresh status
                                    break;
                                }
                            }
                        }
                    }

                }

                AlertConfirm("Section saved successfully","save-success","Success");
                onDismiss();
                
            },
            (error:any)=>{
                setIsloading(false);
                AlertConfirm("Error saving section, please try again");
            });
            }
        else if(saveType === SectionSaveType.EditCategories && editId){ // save only categories

     
            UpdateCategoriesForSection(siteData.userContext,editId,selectedCategories,        
            (data:any)=>{
                setIsloading(false);
                if(onUpdateCategories){
                    onUpdateCategories();
                }
     
                onDismiss();
            },
            (error:any)=>{
                setIsloading(false);
                AlertConfirm("Error updating section, please try again");
            });

        }

        else if(saveType === SectionSaveType.EditContent && editId){ // save both content & categories
            EditSection(siteData.userContext,editId,selectedCategories,content,
                (data:any)=>{
                    UpdateCategoriesForSection(siteData.userContext,editId,selectedCategories,        
                        (data:any)=>{
                            setIsloading(false);
                            if(onUpdateCategories){
                                onUpdateCategories();
                            }
                            AlertConfirm("Section updated successfully","save-success","Success");
                            onDismiss();
                        },
                        (error:any)=>{
                            setIsloading(false);
                            AlertConfirm("Error updating section, please try again");
                        });

                },
                (error:any)=>{
                    setIsloading(false);
                    AlertConfirm("Error updating section, please try again");
                });
        }
    }

    return <>
    {isLoading && <Loader/>}

    <div style={{fontSize:"16px",lineHeight:"20px",paddingBottom:"4px",fontWeight:"600"}}>Section Category:</div>
  
    <div style={{position:"fixed",width:"456px",zIndex:"10"}}>
          <style>
            {`
            .multi-select-option { padding-top:12px !important; padding-bottom:12px !important;
            `}
        </style>
        { 
    <CustomMultiSelect
        startOpen={false}
        options={options}
        key={options.length + (isLoading?"loading":"loaded")}
        placeholder="Select Category"
        defaultValues={selectedCategories}
        onChange={(value:string[])=>{
            setSelectedCategories(value);
            let dom = document.getElementById("save-section-btn");
            (dom as HTMLButtonElement).disabled = value.length==0;
        
        }}
        useDualHeader={true}
        footer={<button 
            onClick={(e) => {
                onDismiss();
                OpenSectionCategoryPopup(siteData,categories,content,onUpdateCategories,()=>{
                    OpenSaveAsSectionMenu(content,siteData,editId,saveType,inCategories,onUpdateCategories);//reopen with same settings when closing the category popup
                });

            }}  
            className="invisible-button bold  bg-w gray-hover" style={{textAlign:"left",padding:"12px 16px",marginBottom:"-8px",position:"sticky",bottom:"-8px"}}
            ><b>+</b> Edit Categories</button>}
        />
}
    </div>
    <div style={{height:"30px"}} ></div>
    <div className="flex-row justify-end gap-med" style={{padding:"24px 6px 6px 0px"}}>
    <button className="w-button w-button-secondary" onClick={(e) => { onDismiss();}}>Cancel</button>
        <button disabled={selectedCategories.length<=0} style={(selectedCategories.length<=0?{opacity:".5",pointerEvents:"none"}:{})} id="save-section-btn" className="w-button w-button-primary" onClick={(e) => { TrySave()}}>Save</button>
    </div>
    </>

}

export function OpenSaveAsSectionMenu(content:string,siteData:SiteData,editId?:string,saveType?:SectionSaveType,inCategories?:string[],onUpdateCategories?:()=>void,srcNode?:LayoutNode){

 
    const dom =  document.getElementById("OpenDialog1");
   
    const PopupClose = ()=>{

        if(dom){
            ReactDOM.unmountComponentAtNode(dom);
        }
    }

    const title = saveType === SectionSaveType.EditCategories?"Edit Section":saveType === SectionSaveType.EditContent?"Update Section": "Save As Section";

    ReactDOM.render(
        <>
        <VGPopUp
          id={"save-section-popup"}
          show={true}
          onHide={PopupClose}
          title={title}
          dialogClassName="block-edit"
          body={
            <div className="alertContent">
                <SaveSectionMenu  editId={editId} saveType={saveType??SectionSaveType.Create} content={content} siteData={siteData} onDismiss={PopupClose} inCategories={inCategories} onUpdateCategories={onUpdateCategories}/>
            </div>
          }
          footer={
            <Fragment>
             

            </Fragment >
          }
          isRemoveTabModalIndex={false}
          isShowFooter={false}
          size={"modal-sm"}
          backdrop={true}
        />
  
        </>,
        dom);

}